import type { ElementType } from 'react';
import {
    useStyles,
    Caption,
    useTheme,
    Subheader,
    pxToRem,
} from '@archipro-design/aria';
import { Link, useLoaderData } from '@remix-run/react';
import * as S from './PageHeader.style';

import type { loader } from '~/routes/_app.project.$urlSegment._index';

import { useTracker } from '@archipro-website/tracker';

import type { PageHeaderProps } from './PageHeader';
import TopNavMobile from '../top-nav/TopNav.mobile';

export const PageHeaderMobile = ({
    data: { Title, Professional },
}: PageHeaderProps) => {
    const { project } = useLoaderData<typeof loader>();
    const { css } = useStyles();
    const tracker = useTracker();
    const theme = useTheme();

    return (
        <>
            <TopNavMobile
                data={{
                    Breadcrumbs: project.Breadcrumbs.map((breadcrumb) => ({
                        label: breadcrumb.label,
                        as: breadcrumb.as as ElementType | undefined,
                        href: breadcrumb.href,
                    })),
                }}
            />
            <div className={css(S.PageHeader)}>
                <div className={css(S.PageHeaderInner)}>
                    <Subheader
                        as="h1"
                        variant="01"
                        className={css(S.ProjectTitle)}
                        style={{
                            ...theme.siteVariables.textStyles.Heading.Medium65,
                            fontSize: pxToRem(20),
                        }}
                    >
                        {Title}
                    </Subheader>
                    <Link
                        to={Professional.Link}
                        onClick={() => {
                            tracker.log('ProjectProfileClick', {
                                url: new URL(window.location.href),
                                targetTracker: 'archiproTracker',
                            });
                        }}
                        prefetch="intent"
                    >
                        <Caption
                            variant="03"
                            weight="regular"
                            variables={(siteVars) => ({
                                captionColor: siteVars?.colors.charcoal['100'],
                            })}
                            className={css(S.ProjectTitleProfessional)}
                        >
                            By {Professional.Title}
                        </Caption>
                    </Link>
                </div>
            </div>
        </>
    );
};
